<template>
  <b-row>
    <b-col v-if="!tableDetail">
      <b-row>
        <b-col lg="12">
          <div v-if="!loading">
            <b-table
              :filter="filter"
              :dark="dark"
              :hover="hover"
              :striped="striped"
              :bordered="bordered"
              :small="small"
              :fixed="fixed"
              responsive="sm"
              :items="items"
              :fields="captions"
              head-variant="light"
              :current-page="currentPage"
              :per-page="perPage"
              :show-empty="true"
              :redirect-detail="redirectDetail"
            >
              <template v-slot:cell(date)="data">
                <div v-if="data.item.date" v-html="dateFormat(data.item.date)"></div>
              </template>

              <template v-slot:cell(date_inserted)="data">
                <div v-if="data.item.date_inserted" v-html="dateFormat(data.item.date_inserted)"></div>
              </template>

              <template v-slot:cell(permission_date)="data">
                <div v-html="dateFormatRange(data.item.permission_date)"></div>
              </template>

              <template v-slot:cell(leave_date)="data">
                <div v-html="dateFormatRange(data.item.leave_date)"></div>
              </template>

              <template v-slot:cell(date_mass_leave)="data">
                <div
                  v-if="data.item.date_mass_leave"
                  v-html="dateFormat(data.item.date_mass_leave)"
                ></div>
              </template>

              <template v-slot:cell(start_join)="data">
                <div v-if="data.item.start_join" v-html="dateFormat(data.item.start_join)"></div>
              </template>

              <template v-slot:cell(status)="data">
                <b-badge :variant="getBadge(data.item.status)">{{data.item.status}}</b-badge>
              </template>

              <template v-slot:cell(price_plan)="data">
                <div v-html="'Rp. ' + formatPrice(data.item.price_plan)"></div>
              </template>

              <template v-slot:cell(total_price_plan)="data">
                <div v-html="'Rp. ' + formatPrice(data.item.total_price_plan)"></div>
              </template>


              <template v-slot:cell(show_detail)="data">
                <b-button
                  type="button"
                  @click="showDetail($event,data)"
                  size="sm"
                  variant="primary"
                  title="Show this data"
                >
                  <i class="cui-note icons"></i>
                </b-button>
              </template>

              <template v-slot:cell(action)="data">
                <b-button
                  v-if="redirectDetail"
                  type="button"
                  @click="goToDetail(data.item)"
                  size="sm"
                  variant="primary"
                  title="Go To detail"
                >
                  <i class="cui-note icons"></i>
                </b-button>
                <b-button
                  v-else-if="!redirectDetail"
                  type="button"
                  @click="editForm(data.item)"
                  size="sm"
                  variant="primary"
                  title="Edit this data"
                >
                  <i class="cui-note icons"></i>
                </b-button>&nbsp;
                <b-button
                  v-if="removeButton"
                  type="button"
                  size="sm"
                  variant="danger"
                  title="Remove this data"
                >
                  <i class="cui-circle-x icons"></i>
                </b-button>
              </template>
            </b-table>
            <nav v-if="!loading">
              <b-pagination
                align="right"
                size="sm"
                :total-rows="totalRows"
                :per-page="perPage"
                v-model="currentPage"
                prev-text="Prev"
                next-text="Next"
                hide-goto-end-buttons
              />
            </nav>
          </div>

          <div v-else>
            <div class="text-center sk-spinner sk-spinner-pulse"></div>
            <p class="text-center" style="color: #CCC;">Please wait . . .</p>
          </div>
        </b-col>
      </b-row>
    </b-col>

    <b-col v-else-if="tableDetail">
      <b-row>
        <b-col lg="12">
          <div v-if="!loading">
            <b-button
              size="sm"
              v-if="showAddButton"
              v-on:click.prevent="addForm($event.target)"
              variant="stack-overflow"
              style="margin-bottom:10px;"
              class="mr-1 btn-brand float-right"
            >
              <i class="fa fa-plus"></i>
              <span>{{addButton}}</span>
            </b-button>

            <b-table
              :dark="dark"
              :hover="hover"
              :striped="striped"
              :bordered="bordered"
              :small="small"
              :fixed="fixed"
              responsive="sm"
              :items="items"
              :fields="captions"
              head-variant="light"
              :current-page="currentPage"
              :per-page="perPage"
              :show-empty="true"
              :redirect-detail="redirectDetail"
            >
              <template v-slot:cell(dob)="data">
                <div v-html="dateFormat(data.item.dob)"></div>
              </template>

              <template v-slot:cell(start_join)="data">
                <div v-if="data.item.start_join" v-html="dateFormat(data.item.start_join)"></div>
              </template>

              <template v-slot:cell(start_date)="data">
                <div v-if="data.item.start_date" v-html="dateFormat(data.item.start_date)"></div>
              </template>

              <template v-slot:cell(end_date)="data">
                <div v-if="data.item.end_date" v-html="dateFormat(data.item.end_date)"></div>
              </template>

              <template v-slot:cell(status)="data">
                <b-badge :variant="getBadge(data.item.status)">{{data.item.status}}</b-badge>
              </template>

              <template v-slot:cell(show_detail)="data">
                <b-button
                  type="button"
                  @click="showDetail($event, data)"
                  size="sm"
                  variant="primary"
                  title="Show this data"
                >
                  <i class="cui-note icons"></i>
                </b-button>
              </template>

              <template v-slot:cell(action)="data">
                <b-button
                  v-if="redirectDetail"
                  type="button"
                  @click="goToDetail(data.item)"
                  size="sm"
                  variant="primary"
                  title="Go To detail"
                >
                  <i class="cui-note icons"></i>
                </b-button>
                <b-button
                  v-else-if="!redirectDetail"
                  type="button"
                  @click="editForm(data.item)"
                  size="sm"
                  variant="primary"
                  title="Edit this data"
                >
                  <i class="cui-note icons"></i>
                </b-button>&nbsp;
                <b-button
                  v-if="removeButton"
                  type="button"
                  size="sm"
                  variant="danger"
                  title="Remove this data"
                >
                  <i class="cui-circle-x icons"></i>
                </b-button>
              </template>
            </b-table>
            <nav v-if="!loading">
              <b-pagination
                align="right"
                size="sm"
                :total-rows="totalRows"
                :per-page="perPage"
                v-model="currentPage"
                prev-text="Prev"
                next-text="Next"
                hide-goto-end-buttons
              />
            </nav>
          </div>

          <div v-else>
            <div class="text-center sk-spinner sk-spinner-pulse"></div>
            <p class="text-center" style="color: #CCC;">Please wait . . .</p>
          </div>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import * as moment from "moment";

export default {
  name: "global-table-only",
  inheritAttrs: false,
  props: {
    caption: {
      type: String,
      default: "Table"
    },
    addButton: {
      type: String,
      default: ""
    },
    hover: {
      type: Boolean,
      default: false
    },
    striped: {
      type: Boolean,
      default: false
    },
    bordered: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    fixed: {
      type: Boolean,
      default: false
    },
    redirectDetail: {
      type: Boolean,
      default: true
    },
    showAddButton: {
      type: Boolean,
      default: true
    },
    removeButton: {
      type: Boolean,
      default: false
    },
    tableData: {
      type: [Array, Object],
      default: () => []
    },
    filter: {
      type: String,
      default: ""
    },
    fields: {
      type: [Array, Object],
      default: () => []
    },
    perPage: {
      type: Number,
      default: 5
    },
    dark: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    tableDetail: {
      type: Boolean,
      default: false
    },
    idModals: {
      type: String,
      default: "addModals"
    }
  },
  data: () => {
    return {
      currentPage: 1
    };
  },
  computed: {
    items: function() {
      const items = this.tableData;
      return Array.isArray(items) ? items : Object.values(items);
    },
    totalRows: function() {
      return this.getRowCount();
    },
    captions: function() {
      return this.fields;
    }
  },
  watch: {
    $route(to, from) {
      //console.log(to)
      //console.log(from)
    }
  },
  methods: {
    getBadge: function(status) {
      return status === "Active"
        ? "success"
        : status === "Inactive"
        ? "secondary"
        : status === "Pending"
        ? "warning"
        : status === "Banned"
        ? "danger"
        : "primary";
    },
    goToDetail: function(row) {
      let path = this.$route.path.split("/");
      //console.log(path)
      //
      /*
         this.$router.push({
          path: (path[1] === 'master') ? path[2]+'/detail/'+row.id : 'detail/'+row.id
        })
         */
      this.$router.push({
        path: path.hasOwnProperty("2")
          ? path[2] + "/detail/" + row.id
          : "detail/" + row.id
      });
    },
    editForm: function(row) {
      this.$emit("editForm", row);
      this.$emit("isEdit", true);
      this.$root.$emit("bv::show::modal", this.idModals);
    },
    addForm: function(button) {
      this.$emit("isEdit", false);
      this.$emit("resetForm");
      console.log(this.idModals);
      this.$root.$emit("bv::show::modal", this.idModals, button);
    },
    close: function() {
      console.log("aaa");
    },
    getRowCount: function() {
      return this.items.length;
    },
    dateFormat: function(date) {
      return moment(date).format("DD MMM YYYY");
    },
    showDetail: function(button, row) {
      this.$emit("showDetail", row);
      this.$root.$emit("bv::show::modal", "openDetail", button);
    },
    dateFormatRange: function(date) {
      let temp = "";
      if (date !== "") {
        for (var d in date) {
          temp +=
            temp === ""
              ? moment(date[d]).format("DD MMM YYYY")
              : ", " + moment(date[d]).format("DD MMM YYYY");
        }
        return temp;
      } else {
        return "";
      }
    },
    formatPrice(value) {
      let val = (value / 1).toFixed(0).replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    }
  }
};
</script>
